import * as R from 'ramda';
import { isNot } from './predicates';
const isPlainObject = R.allPass([R.is(Object), isNot(Array)]);
const allHave = R.pipe(R.has(R.__), R.all);
export const getAxiosErrors = R.curry((defaultErrorMessage, errorResponse) => R.pipe(R.path(['response', 'data']), R.cond([
    [R.allPass([R.identity, R.is(String)]), R.of],
    [
        R.allPass([isPlainObject, R.has('detail')]),
        R.pipe(R.prop('detail'), R.of),
    ],
    [R.allPass([R.is(Array), allHave('detail')]), R.map(R.prop('detail'))],
    [
        R.allPass([
            isPlainObject,
            R.pipe(R.prop('errors'), R.allPass([R.is(Array), allHave('message')])),
        ]),
        R.pipe(R.prop('errors'), R.map(R.prop('message'))),
    ],
    [R.T, R.always([defaultErrorMessage])],
]))(errorResponse));
export function throwError(errorMessage) {
    return () => {
        throw new Error(errorMessage);
    };
}
